import React from 'react'
import FilterSelect from './FilterSelect'
import { TCG_CATEGORIES, ACCESSORY_CATEGORIES } from './filterCategories'

const CATEGORY_MAP = {
  tcg: TCG_CATEGORIES,
  accessories: ACCESSORY_CATEGORIES,
}

const SORT_OPTIONS = [
  { value: 'name-asc', label: 'Name (A–Z)' },
  { value: 'name-desc', label: 'Name (Z–A)' },
  { value: 'price-asc', label: 'Price (Low to High)' },
  { value: 'price-desc', label: 'Price (High to Low)' },
]

const CLEAR_COLORS = {
  blue: 'border-blue-300 text-blue-600 hover:bg-blue-50',
  purple: 'border-purple-300 text-purple-600 hover:bg-purple-50',
  indigo: 'border-indigo-300 text-indigo-600 hover:bg-indigo-50',
  emerald: 'border-emerald-300 text-emerald-600 hover:bg-emerald-50',
  red: 'border-red-300 text-red-600 hover:bg-red-50',
}

const SEARCH_FOCUS = {
  blue: 'focus:border-blue-300 focus:ring-2 focus:ring-blue-200',
  purple: 'focus:border-purple-300 focus:ring-2 focus:ring-purple-200',
  indigo: 'focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200',
  emerald: 'focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200',
  red: 'focus:border-red-300 focus:ring-2 focus:ring-red-200',
}

export default function FilterBar({
  category,
  categoryValue = 'All',
  onCategoryChange,
  sortBy,
  onSortChange,
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  onClear,
  activeFilterCount = 0,
  resultCount,
  totalCount,
  resultUnit = 'products',
  colorScheme = 'indigo',
}) {
  const clearCls = CLEAR_COLORS[colorScheme] || CLEAR_COLORS.indigo
  const searchFocus = SEARCH_FOCUS[colorScheme] || SEARCH_FOCUS.indigo
  const categoryOptions = CATEGORY_MAP[category] || []

  return (
    <div className="mb-8 flex flex-col gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap">
        <label className="flex flex-col gap-1 text-sm">
          <span className="font-medium text-gray-700">Search</span>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            className={`w-64 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none transition ${searchFocus}`}
          />
        </label>

        {categoryOptions.length > 0 && (
          <FilterSelect
            label="Categories"
            value={categoryValue}
            options={categoryOptions}
            onChange={onCategoryChange}
            colorScheme={colorScheme}
          />
        )}

        <FilterSelect
          label="Sort by"
          value={sortBy}
          options={SORT_OPTIONS}
          onChange={onSortChange}
          colorScheme={colorScheme}
        />

        {activeFilterCount > 0 && (
          <button
            onClick={onClear}
            className={`self-end rounded-lg border bg-white px-4 py-2 text-sm font-medium transition ${clearCls}`}
          >
            Clear filters
          </button>
        )}
      </div>

      <p className="text-sm text-gray-500">
        {resultCount === 0
          ? 'No products match your filters'
          : `Showing ${resultCount} of ${totalCount} ${resultUnit}`
        }
      </p>
    </div>
  )
}
